export default __webpack_public_path__ + "static/media/digitaal_betaling_mogelijk.66b1f420.svg";